import React from "react";
import { css } from "@emotion/react";

import { colors, heights } from "../assets/styles/variables";
import logoGb from "../assets/images/logo_gb.svg";
import logoFs from "../assets/images/forzastyle_logo_s.png";
import iconArrowBack from "../assets/icons/icon_arrow_back.svg";
import { devices } from "../assets/styles/variables";

interface Props {
  parentArticleUrl: string;
  media: any;
}

const header = css`
  display: flex;
  align-items: center;
  box-sizing: border-box;
  height: ${heights.header};
  padding: 0 10px 0 30px;
  background-color: ${colors.black};
  border-bottom: 2px solid ${colors.lightgray};

  @media screen and (min-width: ${devices.mobile}) {
    padding: 0 15px 0 20px;
  }

  .title {
    flex-grow: 1;
  }

  .button {
    display: flex;
    align-items: center;
    padding: 7px 14px;
    border: none;
    border-radius: 20px;
    font-size: 14px;
    font-weight: bold;
    color: ${colors.black};
    background-color: ${colors.white};
    text-decoration: none;
    outline: none;
    cursor: pointer;

    > img {
      margin-right: 10px;
    }
  }
`;

const Header = (props: Props) => {
  const { parentArticleUrl, media } = props;
  const mediaLogo = media.label == "fs" ? logoFs : logoGb
  const mediaAlt = media.alt ? media.alt : "現代ビジネス"

  return (
    <header css={header}>
      <a href={parentArticleUrl} className="title">
        <h1>
          <img src={mediaLogo} width="86" height="48" alt={mediaAlt} />
        </h1>
      </a>

      <a href={parentArticleUrl} className="button">
        <img src={iconArrowBack} width="16" height="14" alt="" />
        <span>戻る</span>
      </a>
    </header>
  );
};

export default Header;
